import { alpha, Box, Stack, useTheme } from "@mui/material";
import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import type { SwipeableComponentRef } from "web_myplann/Shared/Hooks/useSwipeable";

type Props = {
	length: number;
	currentValue?: number;
	onClick: (val: number, direction?: "left" | "right") => void;
};

export const CarrouselDots = forwardRef<SwipeableComponentRef, Props>(
	({ length, currentValue = 0, onClick }, ref) => {
		const { palette, shape } = useTheme();
		const [value, setValue] = useState(currentValue);

		useEffect(() => {
			setValue(currentValue);
		}, [currentValue]);

		useImperativeHandle(ref, () => ({
			swipeLeft: () => {
				const newVal = value > 0 ? value - 1 : length - 1;

				setValue(newVal);
				onClick(newVal, "left");
			},
			swipeRight: () => {
				const newVal = value > length - 2 ? 0 : value + 1;

				setValue(newVal);
				onClick(newVal, "right");
			},
		}));

		return (
			<Stack direction="row" gap={0.4}>
				{Array.from({ length }).map((_, dotIndex) => (
					<Box
						// biome-ignore lint/suspicious/noArrayIndexKey: Static carousel dots with no unique identifier
						key={dotIndex}
						p={0.5}
						borderRadius={shape.pillRadius}
						bgcolor={
							dotIndex === value
								? palette.darkmodeText.white
								: alpha(palette.darkmodeText.white, 0.4)
						}
						onClick={() => {
							setValue(dotIndex);
							onClick(dotIndex);
						}}
					/>
				))}
			</Stack>
		);
	},
);
